"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileRequests = void 0;
const Paths_1 = require("../Paths");
const Utils_1 = require("../Utils");
const LoadRequests_1 = require("./Requests/LoadRequests");
const MembershipsRequests_1 = require("./Requests/MembershipsRequests");
const SceneRequests_1 = require("./Requests/SceneRequests");
const ScheduleRequests_1 = require("./Requests/ScheduleRequests");
const SwitchRequests_1 = require("./Requests/SwitchRequests");
class ProfileRequests {
    constructor(session, uuid) {
        this.session = session;
        this.uuid = uuid;
        this.scenes = new SceneRequests_1.SceneRequests(this.session, uuid);
        this.switches = new SwitchRequests_1.SwitchRequests(this.session, uuid);
        this.loads = new LoadRequests_1.LoadRequests(this.session, uuid);
        this.schedules = new ScheduleRequests_1.ScheduleRequests(this.session, uuid);
        this.memberships = new MembershipsRequests_1.MembershipsRequests(this.session, uuid);
    }
    getProfile() {
        return __awaiter(this, void 0, void 0, function* () {
            const options = {
                method: Paths_1.Methods.GET,
            };
            const request = yield (0, Utils_1.buildGenericRequest)(this.session, options);
            const endpoint = this.getRootEndpoint();
            return (0, Utils_1.wrapFetchJson)(request, endpoint);
        });
    }
    getLoadState() {
        return __awaiter(this, void 0, void 0, function* () {
            const options = {
                method: Paths_1.Methods.GET,
            };
            const request = yield (0, Utils_1.buildGenericRequest)(this.session, options);
            const endpoint = this.getRootEndpoint(Paths_1.Constants.STATE);
            return (0, Utils_1.wrapFetchJson)(request, endpoint);
        });
    }
    getSwitchStates() {
        return __awaiter(this, void 0, void 0, function* () {
            const options = {
                method: Paths_1.Methods.GET,
            };
            const request = yield (0, Utils_1.buildGenericRequest)(this.session, options);
            const endpoint = this.getRootEndpoint(Paths_1.Constants.SWITCHSTATE);
            return (0, Utils_1.wrapFetchJson)(request, endpoint);
        });
    }
    getFirmwareUpdateStatus() {
        return __awaiter(this, void 0, void 0, function* () {
            const options = {
                method: Paths_1.Methods.GET,
            };
            const request = yield (0, Utils_1.buildGenericRequest)(this.session, options);
            const endpoint = this.getRootEndpoint(Paths_1.Constants.UPDATE);
            return (0, Utils_1.wrapFetch)(request, endpoint);
        });
    }
    startFirmwareUpdate() {
        return __awaiter(this, void 0, void 0, function* () {
            const options = {
                method: Paths_1.Methods.POST,
                body: {},
            };
            const request = yield (0, Utils_1.buildGenericRequest)(this.session, options);
            const endpoint = this.getRootEndpoint(Paths_1.Constants.UPDATE_START);
            return (0, Utils_1.wrapFetch)(request, endpoint);
        });
    }
    getDiagnostics(invoker) {
        return __awaiter(this, void 0, void 0, function* () {
            const options = {
                method: Paths_1.Methods.POST,
                body: { invoked_by: invoker },
            };
            const request = yield (0, Utils_1.buildGenericRequest)(this.session, options);
            const endpoint = this.getRootEndpoint(Paths_1.Constants.DIAGNOSTICS);
            return (0, Utils_1.wrapFetch)(request, endpoint);
        });
    }
    updateProfile(changes) {
        return __awaiter(this, void 0, void 0, function* () {
            const options = {
                method: Paths_1.Methods.PUT,
                body: changes,
            };
            const request = yield (0, Utils_1.buildGenericRequest)(this.session, options);
            const endpoint = this.getRootEndpoint();
            return (0, Utils_1.wrapFetch)(request, endpoint);
        });
    }
    getRemoteURL() {
        return __awaiter(this, void 0, void 0, function* () {
            const options = {
                method: Paths_1.Methods.POST,
                body: { scope: "remoteaccess" },
            };
            const request = yield (0, Utils_1.buildGenericRequest)(this.session, options);
            const endpoint = this.getRootEndpoint(Paths_1.Constants.REMOTEURL);
            return (0, Utils_1.wrapFetch)(request, endpoint);
        });
    }
    getMQTTSendPath() {
        return `profiles/${this.uuid}/bridge/raw`;
    }
    getMQTTReceivePath() {
        return `profiles/${this.uuid}/raw`;
    }
    pairWifiBridge(thing, token) {
        return __awaiter(this, void 0, void 0, function* () {
            const options = {
                method: Paths_1.Methods.PUT,
                body: {
                    profile_id: this.uuid,
                    token,
                },
            };
            const request = yield (0, Utils_1.buildGenericRequest)(this.session, options);
            const endpoint = this.getWifiEndpoint(thing);
            return (0, Utils_1.wrapFetch)(request, endpoint);
        });
    }
    getRootEndpoint(path) {
        const postfix = typeof path !== "undefined" ? `/${path}` : "";
        return `${this.session.baseUrl}/profiles/${this.uuid}${postfix}`;
    }
    getWifiEndpoint(thing) {
        return `${this.session.baseUrl}/wifibridges/${thing}/links`;
    }
}
exports.ProfileRequests = ProfileRequests;
//# sourceMappingURL=ProfileRequests.js.map